import { render, staticRenderFns } from "./PaymentFeeConfirmDialog.vue?vue&type=template&id=4db056b1&scoped=true"
import script from "./PaymentFeeConfirmDialog.vue?vue&type=script&lang=js"
export * from "./PaymentFeeConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./PaymentFeeConfirmDialog.vue?vue&type=style&index=0&id=4db056b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db056b1",
  null
  
)

export default component.exports